import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SharedModule } from '@shared/modules/shared.module';

import { BRANDING } from 'app/core/constants/branding.constants';

@Component({
	selector: 'app-not-found',
	imports: [SharedModule],
	templateUrl: './not-found.component.html',
	styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {
	readonly brandName = BRANDING.name;
	private router = inject(Router);
	private location = inject(Location);

	handleGoHome(): void {
		this.router.navigate(['/']);
	}

	handleGoBack(): void {
		this.location.back();
	}
}
